export default __webpack_public_path__ + "static/media/corporate-package1.82c9aa2b.png";